import { useId, useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { toast } from 'sonner';
import { useCatalog } from '../../../contexts/CatalogContext';
import { useSignedInAccount } from '../../../contexts/AccountContext';
import { USAGE_STEP_WEEKS } from '../../../core/rules/refillPlan';
const options = [{
  weeks: -USAGE_STEP_WEEKS,
  label: 'Sneller'
}, {
  weeks: 0,
  label: 'Klopt'
}, {
  weeks: USAGE_STEP_WEEKS,
  label: 'Langzamer'
}] as const;

/**
 * "Gaat iets sneller of langzamer op?" per product. Schuift alleen dat product; de dozen rekenen
 * zichzelf opnieuw uit. Ingeklapt: de meeste klanten hebben het nooit nodig.
 */
export function RefillUsage() {
  const {
    account,
    subscription
  } = useSignedInAccount();
  const {
    productById
  } = useCatalog();
  const [open, setOpen] = useState(false);
  const panelId = useId();
  const sub = account.subscription;
  if (!sub || sub.status !== 'actief') return null;
  return <div className="mt-5 border-t border-line pt-4" data-id="element-6098" data-mp="3c9qjzenuy9f9">
      <button type="button" aria-expanded={open} aria-controls={panelId} onClick={() => setOpen(o => !o)} className="flex min-h-[44px] w-full items-center justify-between text-left text-[14px] text-ink" data-id="element-6099" data-mp="3445r6vrgmnh7">
        Gaat iets sneller of langzamer op?
        <ChevronDownIcon className={`h-4 w-4 text-muted transition-transform duration-150 ease-soft ${open ? 'rotate-180' : ''}`} strokeWidth={1.5} aria-hidden="true" data-id="element-6100" data-mp="38694lpxow254" />
      </button>
      {open && <ul id={panelId} className="mt-2 space-y-3" data-id="element-6101" data-mp="3hw2emmi6o979">
          {sub.items.map(item => {
        const product = productById(item.productId);
        if (!product) return null;
        const current = Math.sign(item.usageWeeks ?? 0) * USAGE_STEP_WEEKS;
        return <li key={item.productId} className="flex flex-wrap items-center justify-between gap-2" data-id="element-6102" data-mp="21hkc7x63193n">
                <span className="min-w-0 truncate text-[14px] text-ink" data-id="element-6103" data-mp="1xg8lfobh2htv">{product.name}</span>
                <span role="radiogroup" aria-label={`Hoe snel gaat ${product.name} op`} className="flex rounded-full ring-1 ring-line" data-id="element-6104" data-mp="fcktbhuncsi">
                  {options.map(o => <button key={o.label} type="button" role="radio" aria-checked={current === o.weeks} onClick={async () => {
              if (current === o.weeks) return;
              if (await subscription({
                type: 'setUsage',
                productId: item.productId,
                weeks: o.weeks
              })) toast.success('Aangepast', {
                description: `${product.name}: de volgende dozen houden er rekening mee.`
              });
            }} className={`min-h-[36px] rounded-full px-3 text-[13px] transition-colors duration-150 ease-soft ${current === o.weeks ? 'bg-ink text-shell' : 'text-muted hover:text-ink'}`} data-id="element-6105" data-mp="5gif3dr5r845">
                      {o.label}
                    </button>)}
                </span>
              </li>;
      })}
        </ul>}
    </div>;
}